(() => {
  'use strict';

  const exactTranslations = new Map([
    ['Buy it now', 'Şimdi satın al'], ['Buy now', 'Şimdi satın al'],
    ['Add to cart', 'Sepete kap'], ['Add', 'Sepete ekle'],
    ['Sold out', 'Hepsi satıldı!'], ['Unavailable', 'Şimdilik yok'],
    ['View cart', 'Sepete bak'], ['Cart', 'Sepet'], ['Your cart', 'Sepetin'],
    ['Shopping cart', 'Sepet'], ['Checkout', 'Ödemeye geç'], ['Check out', 'Ödemeye geç'],
    ['Continue shopping', 'Loot toplamaya devam et'], ['Subtotal', 'Ara toplam'],
    ['Total', 'Toplam'], ['Quantity', 'Adet'], ['Remove', 'Kaldır'], ['Close', 'Kapat'],
    ['Open menu', 'Menüyü aç'], ['Close menu', 'Menüyü kapat'], ['Search', 'Ara'],
    ['Search products', 'Ürünlerde ara'], ['Account', 'Hesabım'], ['Log in', 'Giriş yap'],
    ['Login', 'Giriş yap'], ['Sign in', 'Giriş yap'], ['Register', 'Hesap oluştur'],
    ['Create account', 'Hesap oluştur'], ['Email', 'E-posta'], ['Password', 'Şifre'],
    ['Forgot your password?', 'Şifreni mi unuttun?'], ['Reset password', 'Şifreyi yenile'],
    ['Shipping', 'Kargo'], ['Taxes', 'Vergiler'], ['Tax included.', 'Vergiler dahildir.'],
    ['Tax included', 'Vergiler dahil'],
    ['Shipping calculated at checkout.', 'Kargo ödeme adımında hesaplanır.'],
    ['Shipping calculated at checkout', 'Kargo ödeme adımında hesaplanır'],
    ['Taxes and shipping calculated at checkout', 'Vergiler ve kargo ödeme adımında hesaplanır'],
    ['Taxes and shipping calculated at checkout.', 'Vergiler ve kargo ödeme adımında hesaplanır.'],
    ['Free shipping', 'Ücretsiz kargo'], ['Select options', 'Seçenekleri seç'],
    ['Choose options', 'Seçeneklere bak'], ['View full details', 'Tüm detayları gör'],
    ['Product information', 'Ürün bilgileri'], ['Description', 'Açıklama'],
    ['Availability', 'Stok durumu'], ['In stock', 'Stokta'], ['Out of stock', 'Tükendi'],
    ['Reviews', 'Yorumlar'], ['Review', 'Yorum'], ['Write a review', 'Yorum bırak'],
    ['Questions', 'Sorular'], ['Ask a question', 'Soru sor'], ['Sort by', 'Sırala'],
    ['Featured', 'Öne çıkanlar'], ['Best selling', 'Çok satanlar'],
    ['Price, low to high', 'Fiyat: düşükten yükseğe'], ['Price, high to low', 'Fiyat: yüksekten düşüğe'],
    ['Date, new to old', 'En yeniler'], ['Date, old to new', 'En eskiler'],
    ['Load more', 'Daha fazlasını yükle'], ['See all', 'Tümünü gör'],
    ['Powered by Shopify', 'Shopify altyapısıyla'], ['Disclosures', 'Ürün detayları']
  ]);

  const phraseTranslations = [
    [/^More payment options$/i, 'Diğer ödeme seçenekleri'],
    [/^Estimated total$/i, 'Tahmini toplam'],
    [/^Order special instructions$/i, 'Sipariş notu'],
    [/^You may also like$/i, 'Bunlar da hoşuna gidebilir'],
    [/^No reviews yet$/i, 'Henüz yorum yok'],
    [/^Based on (\d+) reviews?$/i, '$1 yoruma göre'],
    [/^(\d+) reviews?$/i, '$1 yorum'],
    [/^View (\d+) items?$/i, '$1 ürünü gör'],
    [/^Add (.+) to cart$/i, '$1 ürününü sepete ekle']
  ];

  const pendingRoots = new Set();
  let scheduled = false;

  function translateString(value) {
    if (!value || value.length > 180) return null;
    const trimmed = value.trim();
    if (!trimmed) return null;
    const exact = exactTranslations.get(trimmed);
    if (exact) return exact;
    for (const [pattern, replacement] of phraseTranslations) {
      if (pattern.test(trimmed)) return trimmed.replace(pattern, replacement);
    }
    return null;
  }

  function translateTextNode(node) {
    const value = node.nodeValue;
    const translated = translateString(value);
    if (!translated) return;
    const leading = value.match(/^\s*/)?.[0] || '';
    const trailing = value.match(/\s*$/)?.[0] || '';
    node.nodeValue = `${leading}${translated}${trailing}`;
  }

  function translateAttributes(element) {
    for (const attribute of ['aria-label', 'title', 'placeholder', 'value']) {
      const value = element.getAttribute?.(attribute);
      const translated = translateString(value);
      if (translated) element.setAttribute(attribute, translated);
    }
  }

  function translateRoot(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('script,style,noscript,template')) return;

    if (root.nodeType === Node.ELEMENT_NODE) translateAttributes(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script,style,noscript,template')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while ((node = walker.nextNode())) translateTextNode(node);
    root.querySelectorAll?.('[aria-label],[title],[placeholder],input[value],button[value]').forEach(translateAttributes);
  }

  function flush() {
    scheduled = false;
    const roots = [...pendingRoots];
    pendingRoots.clear();
    roots.forEach(translateRoot);
  }

  function schedule(root) {
    if (!root) return;
    pendingRoots.add(root);
    if (scheduled) return;
    scheduled = true;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(flush, { timeout: 180 });
    } else {
      window.requestAnimationFrame(flush);
    }
  }

  function boot() {
    schedule(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) schedule(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => schedule(event.target));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
